export default __webpack_public_path__ + "static/media/newLogo.4260cde4.svg";